export function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function orDash(value) {
  return value === null || value === undefined || value === '' ? '-' : value;
}

export function humanize(value) {
  if (value === null || value === undefined || value === '') return '-';
  return String(value).replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
}

export function textCellHtml(value, type) {
  if (type !== 'display') return value ?? '';
  return escapeHtml(orDash(value));
}

export function humanizedCellHtml(value, type) {
  if (type !== 'display') return value ?? '';
  return escapeHtml(humanize(value));
}

export function truncateCellHtml(value, type, max = 40) {
  if (type !== 'display') return value ?? '';
  const text = value === null || value === undefined || value === '' ? '-' : String(value);
  if (text === '-') return text;
  if (text.length <= max) return escapeHtml(text);
  const clipped = `${text.slice(0, max)}...`;
  return `<span title="${escapeHtml(text)}">${escapeHtml(clipped)}</span>`;
}

export function boolBadgeHtml(value, type) {
  if (type !== 'display') return value ? 'True' : 'False';
  const truthy = value === true || value === 1 || value === '1' || String(value).toLowerCase() === 'true';
  const style = truthy
    ? 'background:#dcfce7;color:#15803d;border:1px solid #86efac;'
    : 'background:#f3f4f6;color:#6b7280;border:1px solid #e5e7eb;';
  return `<span style="display:inline-flex;padding:2px 10px;border-radius:6px;font-size:11px;font-weight:600;${style}">${truthy ? 'True' : 'False'}</span>`;
}

export function statusBadgeHtml(value, type, tones = {}) {
  if (type !== 'display') return value ?? '';
  const raw = value === null || value === undefined || value === '' ? '-' : String(value);
  if (raw === '-') return raw;
  const key = raw.toLowerCase();
  const style =
    tones[key] ||
    tones.default ||
    'background:#f3f4f6;color:#6b7280;border:1px solid #e5e7eb;';
  return `<span style="display:inline-flex;padding:2px 10px;border-radius:6px;font-size:11px;font-weight:600;${style}">${escapeHtml(humanize(raw))}</span>`;
}

export function fmtDate(value) {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString('en-NG', { dateStyle: 'medium', timeStyle: 'short' });
}

export function parseApiError(error, fallback = 'Unable to complete the request.') {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    fallback
  );
}

export function actionMenuHtml() {
  return `<button type="button" class="nlims-action-btn" data-action="menu" aria-label="Row actions" style="background:#f0fdf4;border:1px solid #bbf7d0;border-radius:8px;padding:3px 12px;cursor:pointer;color:#15803d;font-weight:800;font-size:15px;letter-spacing:2px;line-height:1.4;">&#8943;</button>`;
}

export function buildSpeciesOptions(rows = []) {
  return rows
    .map((row) => ({
      value: row.uuid ?? row.id ?? '',
      label: `${row.common_name_nigeria || row.species_code || 'Unnamed species'}${row.species_code ? ` (${row.species_code})` : ''}`,
    }))
    .filter((option) => option.value);
}
